/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum RepoActivationState {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    BILLING_REQUIRED = 'BILLING_REQUIRED'
}

export function RepoActivationStateFromJSON(json: any): RepoActivationState {
    return RepoActivationStateFromJSONTyped(json, false);
}

export function RepoActivationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepoActivationState {
    return json as RepoActivationState;
}

export function RepoActivationStateToJSON(value?: RepoActivationState | null): any {
    return value as any;
}

